// eslint-disable-next-line import/prefer-default-export
// export const initialValue = {
//   name: '',
//   stopId: '',
//   fieldId: '',
//   description: '',
//   defaultValue: '',
//   isRequired: true,
//   assetType: '',
//   entityType: '',
//   picklistId: '',
//   polygonArea: false,
//   circleArea: false,
//   activeFlag: false,
//   polygonAreaObj: { radius: '', coordinates: [{ latitude: '', longitude: '' }] },
//   availabilityObj: [
//     { availabilityStartTime: '', availabilityStartDate: '', availabilityEndTime: '', availabilityEndDate: '' },
//   ],
// };
export const initialValue = {
  g_assetName: '',
  g_stop: '',
  g_field: '',
  g_description: '',
  g_assetType: '',
  g_areas: '',
  g_activeFlag: true,
  geo_latitude: '',
  geo_longitude: '',
  entityType: '',
  picklistId: '',
  global_attributes: {},
  polygonArea: false,
  circleArea: false,
  activeFlag: false,
  attachements: [],
  staticList: [],
  geofence_geofenceDetails: {
    type: '',
    radius: '',
    coordinates: [
      { latitude: '', longitude: '' },
      { latitude: '', longitude: '' },
      { latitude: '', longitude: '' },
    ],
  },
  availability_availability: [
    { availabilityStartTime: '', availabilityStartDate: '', availabilityEndTime: '', availabilityEndDate: '' },
  ],
};

export const assetOptions = () => {
  return [
    {
      key: 0,
      text: 'stop',
      value: 'stop',
    },
    {
      key: 1,
      text: 'tank',
      value: 'tank',
    },
    {
      key: 2,
      text: 'well',
      value: 'well',
    },
    {
      key: 3,
      text: 'meter',
      value: 'meter',
    },
    {
      key: 4,
      text: 'equipment',
      value: 'equipment',
    },
  ];
};
export const PICKLIST_OPTIONS = {
  userListPicklist: 'userListPicklist',
  fieldOptions: 'fieldOptions',
  assetOptions: 'assetOptions',
  stopOptions: 'stopOptions',
  attachmentOptions: 'attachmentOptions',
};

export const GEOFENCE_OPTIONS = {
  polygonArea: 'polygonArea',
  circleArea: 'circleArea',
};
